// extracted by mini-css-extract-plugin
export var container = "_d1-0";
export var icon = "_d1-1";
export var text = "_d1-2";